exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Color Defination\r\n   ========================================================================== */\n/**\r\n * main color\r\n */\n/*main color*/\n/*main light color*/\n/*second color*/\n/*used in header*/\n/*dark text color*/\n/*light text color*/\n/*very light color*/\n/*mostly used in buttons*/\n/**/\n/**/\n/**\r\n * main color\r\n */\n.title {\n  font-size: 16px; }\n.field {\n  margin-top: 30px; }\n.field .label {\n    padding: 5px;\n    text-transform: uppercase;\n    font-size: 14px;\n    color: #a0a0a0; }\n.field .value {\n    padding: 5px;\n    font-size: 16px;\n    color: #333; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/personal/personal.component.scss
// module id = ../../../../../src/app/profile/personal/personal.component.scss
// module chunks = main